<!--远程会诊页面我发起-->
<template>
    <div class="consul-launch" v-loading="!isSuccess">
        <div v-if="isSuccess" class="deal-launch-wrap fl">
            <ImageAmplify/>
            <!--<div class="launch-title h42 bgc-gray">远程会诊单</div>-->
            <div class="launch-title1" style="margin-top:10px;">
                <p style="color:#92412B;">状态 : {{consultStatusDescription}}</p>
            </div>
            <div class="launch-content">
                <div class="launch-title1" style="margin-top:10px;">
                    <p>基本信息</p>
                </div>
                <div style="box-sizing:border-box;background: #fff;border-left:1px solid #ecebea;border-right:1px solid #ecebea;padding:0px 0px 10px 0px ">
                    <div class="number-wrap paddingL20 paddingR20 clearfix">
                        <label class="fl" style="color:#92412B">建议使用身份读卡设备</label>
                        <el-input class=" h24 launch-input " style="margin-left:10px;width:150px;"></el-input>
                        <el-button
                                size="small"
                                type="ghost"
                                style="padding:5px 15px;margin-left:10px;"
                                class="ghost-btn">检索</el-button>
                        <label class="fr">会诊费用：
                            <span class="fee-num">￥{{consultFee}}</span>
                        </label>
                    </div>
                    <div class="  consult-content-wrap" style="box-sizing:border-box;padding:0px 20px;">
                        <label><span class="fee-num">*</span>病人姓名</label>
                        <el-input class="w95 h24 launch-input " v-model="consulterName"></el-input>
                        <label>性别</label>
                        <el-select v-model="consulterGender" size="small" class="w60 h24 launch-input">
                            <el-option label="男" value="M"/>
                            <el-option label="女" value="F"/>
                        </el-select>
                        <label>年龄</label>
                        <el-input class="w44 h24 launch-input" v-model="consulterAge"></el-input>
                        <label><span class="fee-num">*</span>患者住院号</label>
                        <el-input  v-model="consulterInhosno" size="small" class="launch-input h24 w180"/>
                        <div class="marginT10">
                            <label><span class="fee-num">*</span>身份证</label>
                            <el-input class="w165 h24 launch-input"    @blur="getAge" v-model="consulterIdcard" :maxlength=18 :minlength=18></el-input>
                            <label><span class="fee-num">*</span>电话号码</label>
                            <el-input class="w120 h24 launch-input" v-model="consulterMobile" :maxlength=11 :minlength=11 @blur="getPhone"></el-input>
                            <!--<label><span class="fee-num">*</span>婚姻</label>-->
                            <label>婚姻</label>
                            <el-select v-model="maritalStatus"
                                       size="small"
                                       :clearable=true
                                       style="width:100px;"
                                       class="w60 h24 launch-input">
                                <el-option label="未婚" value="0"/>
                                <el-option label="已婚" value="1"/>
                                <el-option label="离异" value="2"/>
                                <el-option label="不详" value="3"/>
                            </el-select>
                            <!--<label><span class="fee-num">*</span>职业</label>-->
                            <label>职业</label>
                            <el-select
                                    v-model="consulterJob"
                                    :clearable=true
                                    size="small"
                                    style="width:100px;"
                                    class="w60 h24 launch-input">
                                <el-option label="工人" value="工人"/>
                                <el-option label="农民" value="农民"/>
                                <el-option label="公务员" value="公务员"/>
                                <el-option label="学生" value="学生"/>
                            </el-select>
                        </div>
                        <div class="marginT10">
                            <label><span class="fee-num">*</span>家庭住址:</label>
                            <el-select v-model="provinceId" size="small" placeholder="请选择" @change="getProvincess"  style="width: 114px"  >
                                <el-option
                                        v-for="item in provinces"
                                        :key="item.id"
                                        :label="item.areaName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select v-model="cityId" size="small" placeholder="请选择" @change="getEaras"  style="width: 114px">
                                <el-option
                                        v-for="item in citys"
                                        :key="item.id"
                                        :label="item.areaName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select v-model="regionId" size="small" placeholder="请选择"  style="width: 114px">
                                <el-option
                                        v-for="item in earas"
                                        :key="item.id"
                                        :label="item.areaName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <el-input
                                    v-model="lxdz"
                                    style="width:212px;"
                                    size="small"
                                    placeholder="街道等详细地址选择填写"
                            ></el-input>
                        </div>
                    </div>
                </div>
                <div class="launch-title1" style="margin-top:10px;">
                    <p>简要病史（申请医生填写）</p>
                </div>
                <div style="border-left:1px solid #ecebea;border-right:1px solid #ecebea;background: #fff;box-sizing: border-box;padding:10px 0px 10px 0px;">
                    <div class="paddingL20 paddingR20 marginT10">
                        <el-form  label-width="85px">
                            <span class="required-mark">*</span>
                            <el-form-item label="患者主诉：">
                                <div class="">
                                    <el-input
                                            type="textarea"
                                            v-model="consultContent"
                                            class="item-text"
                                            :maxlength=150
                                            placeholder="请输入主诉内容"/>
                                </div>
                            </el-form-item>
                        </el-form>
                        <el-form  label-width="85px">
                            <span class="required-mark">*</span>
                            <el-form-item label="初步诊断：" >
                                <div class="">
                                    <el-input
                                            type="textarea"
                                            v-model="beforeDiagnose"
                                            class="item-text"
                                            :maxlength=100
                                            placeholder="请输入初步诊断内容"/>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <el-form  label-width="85px" class=" paddingL20 paddingR20">
                        <span class="required-mark">*</span>
                        <el-form-item label="会诊目的：">
                            <div>
                                <el-input
                                        type="textarea"
                                        v-model="consultReason"
                                        class="item-text"
                                        :maxlength=50
                                        placeholder="请输入申请会诊目的（或事由）"/>
                            </div>
                        </el-form-item>
                    </el-form>
                    <el-form  label-position="left" label-width="85px" class="paddingL20 paddingR20">
                        <el-form-item label="病历资料：">
                            <div>
                                <!--<el-button size="small" type="ghost"  @click="linkToCx" class="ghost-btn">电子病历</el-button>-->
                            </div>
                            <div class="add-pic-list fl" style="margin-top:10px;">
                                <ul class="el-upload-list--picture-card el-upload-list">
                                    <li class="el-upload-list__item " v-for="(item,index) in imgList" :key="index">
                                        <img  class="el-upload-list__item-thumbnail" :src="item.attaFileUrl" @click="handleImageAmplify(index, imgList, $event)">
                                    </li>
                                </ul>
                            </div>
                            <div class="add-pic-list fl" style="margin-top:10px;">
                                <el-upload
                                        :action="uploadUrl"
                                        :data="uploadData"
                                        :headers ={sign:PasWord()}
                                        list-type="picture-card"
                                        :before-upload="beforeUpload"
                                        accept="image/gif,image/jpg,image/jpeg,image/png"
                                        :on-success="onSuccessImg"
                                        class="fl"
                                        type="select"
                                        ref="uploadRef"
                                        :on-remove="onRemoveImg"
                                        :file-list="imgUploadList"
                                        :on-preview="handlePreview">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                        </el-form-item>
                        <p class="marginT5" style="color:#afafaf;margin-left:65px;">最多可上传9张图片，支持jpg、png、gif、bmp格式</p>
                        <el-form-item label-position="right" label="病历附件：">
                            <div class="ghost-btn-wrap">
                                <el-upload
                                        :action="uploadUrl"
                                        :data="uploadData"
                                        :headers ={sign:PasWord()}
                                        :before-upload="beforeUploadFile"
                                        :on-remove="onRemoveFile"
                                        :on-success="onSuccessFile"
                                        :file-list="fileUploadList">
                                    <el-button size="small" type="ghost" class="ghost-btn" style="color: #999999; border-color: #999999"><i class="el-icon-upload el-icon--left"></i>添加附件</el-button>
                                </el-upload>
                                <!--已经上传过的附件-->
                                <ul class="el-upload-list el-upload-list--text">
                                    <li class="el-upload-list__item is-success" v-for="(item, index) in fileList" :key="index">
                                        <a class="el-upload-list__item-name" :href="item.attaFileUrl" target="_blank">
                                            <i class="el-icon-document"></i>
                                            {{ item.attaFileName }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                        <p class="marginT5" style="color:#afafaf;margin-left:65px;">仅支持pdf、xls、xlsx、doc、docx、txt、PDF格式，文件小于500M。</p>
                    </el-form>
                </div>
                <div class="launch-title1" style="margin-top:10px;">
                    <p>会诊申请信息</p>
                </div>
                <div style="border-left:1px solid #ecebea;border-right:1px solid #ecebea;background: #fff;box-sizing: border-box;padding:10px 0px 20px 0px;">
                    <div class=" paddingL20 paddingR20">
                        <label><span class="fee-num">*</span>申请类型：</label>
                        <el-select v-model="consultGroupType" size="small" class="launch-input h24">
                            <el-option label="名医会诊" value="名医会诊"/>
                            <el-option label="急会诊" value="急会诊"/>
                            <el-option label="多科会诊" value="多科会诊"/>
                            <el-option label="ICU会诊" value="ICU会诊"/>
                            <el-option label="护理会诊" value="护理会诊"/>
                        </el-select>
                        <label class="marginL10">辅助诊断类型：</label>
                        <el-select v-model="auxiliaryDiagnose" size="small" class="launch-input h24 w80">
                            <el-option label="影像" value="影像"/>
                            <el-option label="病理" value="病理"/>
                        </el-select>
                    </div>
                    <div class="clearfix paddingL20 paddingR20 marginT10">
                        <div class="fl marginR10">
                            <label><span class="fee-num">*</span>会诊医院：</label>
                            <el-select
                                    v-model="hopeHosId"
                                    size="small"
                                    class="launch-input w165 h24 fontSize12"
                                    filterable
                                    @change="getHospId"
                                    :loading="loading"
                                    placeholder="请选择期望会诊医院">
                                <el-option v-for="item in hospList" :label="item.hosName" :value="item.id" :key="item.id"/>
                            </el-select>
                            <label><span class="fee-num">*</span>会诊科室：</label>
                            <el-select
                                    v-model="hopeDeptId"
                                    size="small"
                                    class="launch-input w140 h24 fontSize12"
                                    filterable
                                    @change="getDeptId"
                                    :loading="loading"
                                    placeholder="请选择会诊科室">
                                <el-option v-for="item in deptList" :label="item.deptName" :value="item.id" :key="item.id"/>
                            </el-select>
                        </div>
                        <!--<div class="fl marginR10">-->
                            <!--<label>会诊医生(选填)：</label>-->
                            <!--<el-select-->
                                    <!--v-model="hopeDocId"-->
                                    <!--size="small"-->
                                    <!--class="launch-input w112 h24 fontSize12"-->
                                    <!--filterable-->
                                    <!--:loading="loading"-->
                                    <!--@change="getDocId"-->
                                    <!--placeholder="请选择医生">-->
                                <!--<el-option v-for="item in docList" :label="item.docName" :value="item.id" :key="item.id"/>-->
                            <!--</el-select>-->
                        <!--</div>-->
                        <div class="fl">
                            <label>邀请会诊时间：</label>
                            <!--<input v-model="hopeTime" type="text" class="w150 h24 launch-input fontSize12" placeholder="请填写意向会诊时间"/>-->
                            <el-input v-model="hopeTime" size="small" class="launch-input h24 w130" placeholder="请填写意向时间"/>
                        </div>
                    </div>

                    <!--<div class="consul-form-item h30 consult-content-wrap" >-->
                        <!--<div class="fl">-->
                            <!--<label><span class="fee-num">*</span>申请机构：</label>-->
                            <!--&lt;!&ndash;<el-input class="w95 h24 launch-input " v-model="hosNames"></el-input>&ndash;&gt;-->
                            <!--<el-select-->
                                    <!--v-model="initHosId"-->
                                    <!--size="small"-->
                                    <!--class="launch-input w165 h24"-->
                                    <!--filterable-->
                                    <!--:loading="loading"-->
                                    <!--@change="getInitHospId">-->
                                <!--<el-option v-for="item in hospList" :label="item.hosName" :value="item.hosId" :key="item.hosId"/>-->
                            <!--</el-select>-->
                            <!--<label><span class="fee-num">*</span>申请科室：</label>-->
                            <!--<el-select-->
                                    <!--v-model="initDeptId"-->
                                    <!--size="small"-->
                                    <!--class="launch-input w165 h24"-->
                                    <!--filterable-->
                                    <!--@change="getInitDeptId"-->
                                    <!--:loading="loading"-->
                                    <!--placeholder="请选择申请科室">-->
                                <!--<el-option v-for="item in initDeptList" :label="item.deptName" :value="item.deptId" :key="item.deptId"/>-->
                            <!--</el-select>-->
                            <!--<label><span class="fee-num">*</span>申请医生：</label>-->
                            <!--<el-select-->
                                    <!--v-model="initDocId"-->
                                    <!--size="small"-->
                                    <!--class="launch-input w165 h24"-->
                                    <!--filterable-->
                                    <!--:loading="loading"-->
                                    <!--@visible-change="getInitDocList"-->
                                    <!--@change="getInitDocId"-->
                                    <!--placeholder="请选择申请医生">-->
                                <!--<el-option v-for="item in initDocList" :label="item.docName" :value="item.docId" :key="item.docId"/>-->
                            <!--</el-select>-->
                        <!--</div>-->
                    <!--</div>-->

                    <div class="clearfix paddingL20 paddingR20 marginT10">
                        <div class="fl marginR10">
                            <label><span class="fee-num">*</span>申请机构：</label>
                            <!--<el-input class="w95 h24 launch-input " v-model="hosNames"></el-input>-->
                            <el-select
                                    v-model="initHosId"
                                    size="small"
                                    :disabled="selected"
                                    class="launch-input w165 h24"
                                    filterable
                                    :loading="loading"
                                    @change="getInitHospId">
                                <el-option v-for="item in hospList" :label="item.hosName" :value="item.id" :key="item.id"/>
                            </el-select>
                            <label><span class="fee-num">*</span>申请科室：</label>
                            <el-select
                                    v-model="initDeptId"
                                    size="small"
                                    :disabled="selected"
                                    class="launch-input w165 h24"
                                    filterable
                                    @visible-change="getInitDeptList"
                                    @change="getInitDeptId"
                                    :loading="loading"
                                    placeholder="请选择申请科室">
                                <el-option v-for="item in initDeptList" :label="item.deptName" :value="item.id" :key="item.id"/>
                            </el-select>
                            <label><span class="fee-num">*</span>申请医生：</label>
                            <el-select
                                    v-model="initDocId"
                                    size="small"
                                    :disabled="selected"
                                    class="launch-input w165 h24"
                                    filterable
                                    :loading="loading"
                                    @visible-change="getInitDocList"
                                    @change="getInitDocId"
                                    placeholder="请选择申请医生">
                                <el-option v-for="item in initDocList" :label="item.docName" :value="item.id" :key="item.id"/>
                            </el-select>
                            <!--<label><span class="fee-num">*</span>申请医院：</label>-->
                            <!--<span>{{consultDetail.consultGroup.initHosName}}</span>-->
                            <!--<label style="margin-left:20px;"><span class="fee-num">*</span>申请科室：</label>-->
                            <!--<span>{{consultDetail.consultGroup.initDeptName}}</span>-->
                            <!--<label style="margin-left:20px;"><span class="fee-num">*</span>申请医生：</label>-->
                            <!--<span>{{consultDetail.consultGroup.initDocName}}</span>-->
                            <label style="margin-left:20px;"><span class="fee-num">*</span>申请时间：</label>
                            <span>{{formatUnix(consultDetail.consultGroup.createTime)}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="marginB20 ">-->
                <!--<div class="blue-btn-wrap clearfix" v-if="isConsultReady">-->
                <!--</div>-->
            <!--</div>-->
            <div v-if="!isShowVideo" style="margin-top:10px;">
                <div class="consul-form-item" v-if="consultStatus!='CANCEL'&&consultDetail.consultGroup.consultGroupNo.charAt(0)=='A'">
                    <div   class="launch-title1">
                        <label>资料审核（资料未就绪状态不能开启会诊）</label>
                    </div>
                    <div   class="sheet-content" style="box-sizing:border-box;padding:0px 20px;background: #fff;border-left:1px solid #ecebea;border-right:1px solid #ecebea;">
                        <div v-if="!auditStatus">
                            <p v-if="!consultDetail.consultGroup.auditStatus&&consultDetail.consultGroup.remark" class="fee-num">{{ '资料未就绪：'+consultDetail.consultGroup.remark }}</p>
                            <p v-else>未审核</p>
                        </div>
                        <div v-else>
                            <p>资料已就绪</p>
                        </div>
                    </div>
                </div>
                    <div   class="consul-form-item sds">
                        <div class="ghost-btn-wrap clearfix ">
                            <div class="launch-title1" style="margin-top:10px;">
                                <label>会诊安排信息</label>
                            </div>
                            <!--<el-button-->
                                    <!--type="primary"-->
                                    <!--class="blue-btn submit-btn fr sdd"-->
                                    <!--@click="inviteVideo"-->
                                    <!--size="small">邀请医生</el-button>-->
                        </div>
                        <div class="lineH22  " style="background: #fff;  padding:10px 0px 20px 20px;">
                            <div v-if="consultStatus!='CANCEL'">
                                <label class="jet-gray">会诊医生：</label>
                                <span>{{ isConsultReady?(consultDetail.consultGroup.acceptHosName+' - '+consultDetail.consultGroup.acceptDeptName+' - '+consultDetail.consultGroup.acceptDocName):'未安排'}}</span>
                                <label class="marginL15 jet-gray">会诊时间：</label>
                                <span>{{ isConsultReady?selectDate:'未安排' }}</span>
                            </div>
                            <div v-if="!consultDetail.consultGroup.auditStatus&&consultDetail.consultGroup.remark&&consultDetail.consultGroup.consultGroupNo.charAt(0)=='D'">
                                <label class="jet-gray">资料未就绪：</label>
                                <span class="fee-num">{{ consultDetail.consultGroup.remark }}</span>
                            </div>
                            <div v-for="(item, index) in inviteVoList" :key="index">
                                <label class="jet-gray">邀请医生</label>
                                <span>{{ item.hosName+' - '+item.deptName+' - '+item.userName }}</span>
                            </div>
                            <div v-if="consultStatus=='CANCEL'">
                                <label class="jet-gray">拒绝会诊：</label>
                                <span class="fee-num">{{ consultDetail.consultGroup.disagreeReason? consultDetail.consultGroup.disagreeReason:'无' }}</span>
                            </div>
                        </div>
                    </div>
                    <div   class="consul-form-item h30 consult-content-wrap bgc-white">
                        <div class="fr">
                            <label class="light-gray">处理时间：</label>
                            <span class="label-content light-gray">{{ consultDetail.consultGroup.modifyTime?formatUnix(consultDetail.consultGroup.modifyTime):'无' }}</span>
                            <label class="light-gray">处理人：</label>
                            <span class="label-content light-gray">{{ consultDetail.consultGroup.acceptDocName?consultDetail.consultGroup.acceptDocName:'无'}}</span>
                        </div>
                    </div>
                    <div class="submit-btn-wrap blue-btn-wrap btn-position" style="width:56%;margin-left:22%;margin-top:20px;height:40px;display:flex;justify-content:center;">
                    <el-button
                            type="primary"
                            v-if="!isConsultReady&&consultStatus!='CANCEL'"
                            class="blue-btn submit-btn h36 sef f2 "
                            size="small"
                            @click="cancelConsult">
                        取消申请
                    </el-button>
                    <el-popover
                            ref="popoverConfirm"
                            placement="top"
                            v-if="!isShowVideo&&isConsultReady"
                            width="166">
                        <div class="ghost-btn-wrap w180">
                            <el-dropdown @command="linkEnterHD">
                                <el-button type="ghost" size="small" class="ghost-btn w80">
                                    高清视频<i class="el-icon-caret-bottom el-icon&#45;&#45;right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item class="fontSize12 h30" command="560222@cucmp1.onecc.me">DX70</el-dropdown-item>
                                    <el-dropdown-item class="fontSize12 h30" command="560020@onecc.me">DX80</el-dropdown-item>
                                    <el-dropdown-item class="fontSize12 h30" command="55002@onecc.me">IS5000</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-button type="ghost" size="small" :loading="submits" class="ghost-btn w80" @click="linkToEnter" >电脑</el-button>
                        </div>
                    </el-popover>
                    <el-button
                            v-if="!isShowVideo&&isConsultReady"
                            :disabled="!isConsultReady"
                            type="primary"
                            v-show="showscci"
                            :class="[isConsultReady?'blue-btn':'gray-btn',,'submit-btn','h36 ','sef','f2']"
                            size="small"
                            v-popover:popoverConfirm>进入诊间
                    </el-button>
                        <el-button
                                v-if="!isShowVideo&&isConsultReady"
                                @click="linkToEnterHushi"
                                :loading="showVideos"
                                :disabled="!isConsultReady"
                                type="primary"
                                :class="[isConsultReady?'blue-btn':'gray-btn',,'submit-btn','h36 ','sef','f2']"
                                size="small">进入诊间
                        </el-button>
                    <el-button v-if="!isShowVideo&&isConsultReady"
                               type="primary"
                               :class="[isConsultReady?'blue-btn':'gray-btn','submit-btn','h36 ','w150','f2']"                       :disabled="!isConsultReady"
                               size="small "
                               @click="linkToEnd">完成会诊
                    </el-button>
                    <el-button
                            type="primary"
                            class="blue-btn submit-btn h36 sef f2 "
                            @click="consultSubmit">
                        提交
                    </el-button>
                    <el-button v-if="!isShowVideo&&isConsultReady"
                               type="primary"
                               :disabled="showsVideo"
                               :class="[isConsultReady?'blue-btn':'gray-btn','submit-btn','h36 ','sef','f2']" size="small "
                               @click="linkToCancel">取消会诊
                    </el-button>
                    <!--disabled="isConsultReady&&auditStatus||consultStatus=='-1'"-->
                    <!--v-if="!isConsultReady&&auditStatus&&!isModifyByMyself"-->
                    <!--:class="[isConsultReady&&auditStatus||consultStatus=='CANCEL'?'gray-btn':'blue-btn' ,'submit-btn', 'h36', 'w200']"-->
                </div>
            </div>
            <div class="live-wrap" v-if="isShowVideo" >
                <video v-if="isTest" ref="video" style="display:block; background-color:black; width:800px; height:418px; margin:0; padding:0;" :src="testSrc"></video>
                <iframe v-else allowfullscreen :src="videoSrc" frameborder="0" style="display:block; background-color:black; width:800px; height:418px; margin:0; padding:0;" >
                </iframe>
                <div class="live-bottom h49 blue-btn-wrap clearfix">
                    <el-button v-if="!isTest" type="primary" class="blue-btn h24 w112 marginL10 fr" @click="linkToEnd">完成会诊</el-button>
                    <el-button type="primary" class="blue-btn h24 w112 fr" @click="linkToOut">{{ isTest?'退出测试':'临时退出' }}</el-button>
                </div>
            </div>
        </div>
        <AddDoctorMsgBox v-if="isShowAddDocBox" @hide="hiddenAddDocBox" type="remoteVideo" :consultId="consultId"/>
    </div>
</template>
<script>
    import AddDoctorMsgBox from "../common/AddDoctorMsgBox.vue";
    import {upLoadBasicParam} from "../../data/basicParam";
    import { formatUnixTime, formatTimeStamp } from "../../utils/DateFormat.js";
    import fileClassification from "../../utils/FileClassificationUtils";
    import ImageAmplify from "../common/ImageAmplify.vue";
    import { showTestVideo } from "../../utils/VideoTestUtils"
    import html2Escape from "../../utils/Html2Escape"
    import { imageAmplify } from "../../utils/AmplifyImage.js";
    import { API_URL } from "../../data/Url";
    import axiosUtil from "../../utils/AxiosUtils.js"
    import { DirectEnterConf }  from "../../utils/hushi-video.js";
    import {mapActions} from "vuex"
    const upLoadFileCountMax = 9;//最大上传数量
    export default{

        data: function(){
            return {
                selected:false,
                maritalStatus:"",
                showsVideo:false,
                version:"",
                hopeDocIds:"",
                showVideos:false,
                showscci:false,
                showshushi:false,
                record:true,
                consultStatusDescription:"待提交",
                submits:false,
                consultDetail: null,//会诊单详细信息
                type: "ASS",//发起会诊的类型，AAS为医助医，DOC为医医
                consulterName: "",//患者姓名
                consulterIdcard: "",//患者证件号
                consulterMobile: "",//患者手机
                consulterGender: "",//性别
                consulterAge: "",//年龄
                consulterJob: "",//患者执业
                consulterInhosno: "",//住院号
                consulterInhosnoType: 0,//住院号类型
                auxiliaryDiagnose: "影像",//辅助类型
                consultGroupType: "",//会诊类型
                consultContent: "",//主诉
                consultReason: "",//会诊目的
                beforeDiagnose: "",//会诊前诊断
                hopeHosName: "",
                hopeHosId: null,//期望医院ID
                hopeDeptName: "",
                hopeDeptId: null,//期望科室
                hopeDocName: "",
                hopeDocId: null,//期望医生ID
                hopeTime: null,//期望时间
                initHosId:"",//申请医院
                initDeptId:"",//申请科室
                initDocId:"",//申请医生

                provinces:[],
                citys:[],
                earas:[],
                lxdz:"",
                provinceId:"",
                cityId:"",
                regionId:"",

                isArrange: 1,//是否已经安排会诊
                selectDate: "",//选择会诊时间
                selectDoctor: JSON.parse(sessionStorage.getItem("loginInfo")).docName,//选择会诊医生
                rejectContent: "",//拒绝会诊理由
                isShowAddDocBox: false,//是否显示邀请医生弹出窗
                isSuccess: false,//是否加载成功
                isEnd: false,//是否能够结束视频
                isEntry: false,//是否能够进入视频
                isTest: false,//是否是进入测试环境
                isShowVideo: false,//是否显示视频窗口(当提交安排会诊后显示，拒绝无法显示)
                isVideoReady: false,//视频是否准备完成
                videoSrc: "",//视频直播地址

                hosList: [],//获取医院列表
                deptList: [],//获取科室列表
                docList: [],//获取医生列表
                initDeptList:[],
                initDocList:[],
                imgList: [],//获取附件图片
                fileList: [],//获取附件文件
                loading: false,//是否正在从远程获取数据
                uploadFileCount: 0,//上传的文件数量，最大为9个

                /*上传图片*/
                uploadData: {},//up-load组件的data数据
                imgUploadList: [],//需上传的图片列表
                fileUploadList: [],//需上传的文件列表
                attaIdList: [],//需要提交的附件列表
                uploadUrl: API_URL,//上传图片action地址
                docIds:"",
                form:{//互视频视频
                    txtServerAddress:"114.55.29.216",
                    txtServerPort:"17979",
                    txtUserNickname:JSON.parse(sessionStorage.getItem("loginInfo")).doc.docName,
                    txtConfID:""}
            }
        },
        computed: {
            consultId: function(){//获取会诊单编号
                return this.$route.params.consultId;//获取会诊单编号
            },
            isConsultReady: function(){//判断该会诊单是否已经安排时间和医生
                if(this.consultDetail.consultGroup.consultTime){
                    this.selectDate = formatUnixTime(this.consultDetail.consultGroup.consultTime);//如果已经选择了时间则设置已经选择的
                    this.selected=true;
                    return true;
                }else{
                    return false;
                }
                if(this.consultDetail.consultGroup.readyStatus){
                    return false;
                }else{
                    return true;
                }
            },
            auditStatus: function () {//资料审核是否通过,默认为true，所以需要结合最后处理人是否是自己判断是否有审核过资料)
                return  this.consultDetail.consultGroup.readyStatus;
            },
            consultStatus: function () {//会诊单状态
                return this.consultDetail.consultGroup.consultStatus;
            },
            upLoadList: function () {//获取上传图片和文件的id
                let imgUploadListArr = [];
                let fileUploadListArr = [];
                for(let i=0; i<this.imgUploadList.length; i++){
                    imgUploadListArr.push(this.imgUploadList[i].response.obj);
                }
                for(let i=0; i<this.fileUploadList.length; i++){
                    fileUploadListArr.push(this.fileUploadList[i].response.obj);
                }
                return this.imgList.concat(imgUploadListArr, fileUploadListArr, this.fileList);
            },
            inviteVoList: function () {//获取已经邀请的医生列表
                return this.$store.state.inviteVoList;
            },
            dealDoc: function () {//处理医生
                if(this.consultDetail.consultGroup.modifyTime){
                    if(this.consultDetail.consultGroup.modifierType=="ASS"){
                        return this.consultDetail.consultGroup.modifierName;
                    }
                }
            },
            endConsult: function() {//动态检查是否结束会诊
                return this.$store.state.endConsultId==this.consultId;
            },
            refreshConsult: function() {// 动态检查患者是否补充了资料，进行重新刷新
                return this.$store.state.refreshConsultId == this.consultId;
            }
        },

        filters:{},
        components:{
            AddDoctorMsgBox,
            ImageAmplify
        },
        mixins:[],


        created(){//获取会诊单数据
            this.getConsultDetail();
            this.changeSideItem("ychz");//侧边栏高亮
        },
        mounted(){
            let _this=this;
            _this.getHospList();
            _this.getProvices();
            _this.getVersion();
        },
        beforeDestroy(){//组件销毁前如果视频房间未退出则调用退出接口
            /*if(this.isShowVideo == true){
                this.linkToOut();
            }*/
        },
        watch: {
            // 如果路由有变化，会再次执行获取会诊单方法
            "$route": "getConsultDetail",
            "endConsult": function(newVal, oldVal) {// 如果推送已完成，跳转到评论
                if(newVal == true){
                    this.$router.push({ name: "remoteEvaluate", params: { consultId: this.consultId }} );
                }
            },
            "refreshConsult": function(newVal, oldVal) {// 如果补充了资料则重新刷新
                if(newVal === true){
                    this.getConsultDetail();
                    this.$store.dispatch("getRefreshConsultId", null);// 初始化需要刷新的id
                }
            }
        },
        methods: {
            async getProvices(){
                let options={
                    //Service:"smarthos.system.area.list",
                    areaCode:"",
                    areaLevel:1
                }

                let data=await this.$http("smarthos.system.area.list",options);
                this.provinces=data.obj

                /*axiosUtilaxiosUtil(options,function(data){
                    _this.provinces=data.obj
                })*/
            },
            getProvincess:function(){
                let _this=this;
                _this.cityId="";
                _this.regionId="";
                let options={
                    Service:"smarthos.system.area.list",
                    areaCode:_this.provinceId,
                    areaLevel:2
                }
                axiosUtil(options,function(data){
                    _this.citys=data.obj;
                })
            },
            getProvincess1:function(){
                let _this=this;
                let options={
                    Service:"smarthos.system.area.list",
                    areaCode:_this.provinceId,
                    areaLevel:2
                }
                axiosUtil(options,function(data){
                    _this.citys=data.obj;
                })
            },
            getEaras:function(){
                let _this=this;
                _this.regionId="";
                let options={
                    Service:"smarthos.system.area.list",
                    areaCode:_this.cityId,
                    areaLevel:3
                }
                axiosUtil(options,function(data){
                    _this.earas=data.obj;
                })
            },
            getEaras1:function(){
                let _this=this;
                let options={
                    Service:"smarthos.system.area.list",
                    areaCode:_this.cityId,
                    areaLevel:3
                }
                axiosUtil(options,function(data){
                    _this.earas=data.obj;
                })
            },
            getVersion:function(){
              let _this=this;
              let options={
                  Service:"smarthos.system.param.string",
                  key:"VIDEO_SP_HUSHI_PC_BUILD_VERSION",
                  defaultString:"1"
              }
              axiosUtil(options,function(data){

                  _this.version=data.obj;
              })
            },
            getrecord:function(){
                let _this=this;

                if(_this.consultDetail.consultGroup.initHosName.indexOf("长兴")>=0){
                    _this.record=false;
                }else{
                    _this.record=true;
                }
            },
            linkToCx:function(){
                let _this=this;

                if(_this.consulterIdcard!=""){
                    let options={
                        idCard:_this.consulterIdcard,
                        token: localStorage.getItem("token"),
                        Service:"smarthos.book.emr.patient"
                    }
                    axiosUtil(options,function(data){
                            if(data.list){
                                if(data.list.length>0){
                                    window.localStorage.setItem("patInfo", JSON.stringify(data.list[0]));
                                    window.open("./?from=ins#/linkCx");
                                }else{
                                    Message({
                                        showClose: true,
                                        message: "该身份证号在长兴医院没有病历",
                                        type: "warning"
                                    });
                                }
                            }else{
                                Message({
                                    showClose: true,
                                    message: "该身份证号在长兴医院没有病历",
                                    type: "warning"
                                });
                            }
                    })
                }else{
                    Message({
                        showClose: true,
                        message: "请输入18位身份证号",
                        type: "warning"
                    });
                }
            },
            getPhone:function(){
                let _this=this;
                if(_this.consulterMobile){
                    let myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
                    if(!myreg.test(_this.consulterMobile)){
                        _this.consulterMobile="";
                        Message({
                            showClose: true,
                            message: "手机号码输入有误！",
                            type: "error"
                        });
                    }
                }
            },
            getAge:function(){
                let date = new Date();
                let year = date.getFullYear();
                if(this.consulterIdcard.length == 18){
                    var code = this.consulterIdcard.split('');
                    //∑(ai×Wi)(mod 11)
                    //加权因子
                    var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
                    //校验位
                    var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
                    var sum = 0;
                    var ai = 0;
                    var wi = 0;
                    for (var i = 0; i < 17; i++)
                    {
                        ai = code[i];
                        wi = factor[i];
                        sum += ai * wi;
                    }
                    var last = parity[sum % 11];
                    if(parity[sum % 11] != code[17]){
                        this.consulterIdcard="";
                        Message({
                            showClose: true,
                            message: "身份证号码输入有误，请重新输入",
                            type: "error"
                        });
                        return false;
                    }else{
                        this.consulterAge=year-this.consulterIdcard.substring(6,10);
                        if(this.consulterIdcard.substring(16,17)%2==0){
                            this.consulterGender="F";
                        }else{
                            this.consulterGender="M";
                        }
                    }
                    window.localStorage.setItem("patIdcard",this.consulterIdcard)
                }else{
                    this.consulterIdcard="";
                    Message({
                        showClose: true,
                        message: "身份证号号码为18位",
                        type: "warning"
                    });
                }
            },
            PasWord: function () {
                let options = {
                    'Service': "smarthos.system.atta.upload"
                };
                return upLoadBasicParam.sign
            },
            formatUnix: function(time){//将unix时间戳转换未yyyy-MM-dd HH:mm
        	     return formatUnixTime(time);
        	},
            getConsultDetail(){//根据consultId获取会诊单数据
                this.isSuccess = false;
                let _this = this;
                let options = {
                    consultId: _this.consultId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.detail"
                };
                axiosUtil(options, function(data){

                    _this.docIds=data.obj.consultGroup.id;
                    if(localStorage.getItem("txtConfID"+_this.docIds)){

                        _this.showsVideo=true;
                    }
                    _this.consultStatusDescription=data.obj.consultStatusDescription;
                    if(data.obj.consultGroup.consultStatus === "GOING"){// 会诊未完成或者未取消
                        _this.isSuccess = true;
                        _this.maritalStatus=data.obj.consultGroup.maritalStatus;
                        _this.consulterName = data.obj.consultGroup.consulterName;//患者姓名
                        _this.consulterIdcard = data.obj.consultGroup.consulterIdcard;//患者证件号
                        _this.consulterMobile = data.obj.consultGroup.consulterMobile;//患者手机
                        _this.consulterGender = data.obj.consultGroup.consulterGender;//性别
                        _this.consulterAge = data.obj.consultGroup.consulterAge;//年龄
                        _this.consulterJob = data.obj.consultGroup.consulterJob;//患者职业
                        _this.consultFee = data.obj.consultGroup.consultFee;//会诊费用
                        _this.lxdz=data.obj.consultGroup.consulterAddress;
                        _this.consulterDiagnoseLevel=data.obj.consultGroup.consulterDiagnoseLevel;//患者病情情况
                        _this.zzqk=data.obj.consultGroup.referralSituation;//是否建议转诊
                        _this.regionId=data.obj.areaNameArr[3];
                        _this.cityId=data.obj.areaNameArr[3].substring(0,4)+"00";
                        _this.provinceId=data.obj.areaNameArr[3].substring(0,2)+"0000";
                        _this.getProvincess1();
                        _this.getEaras1();
                        _this.consulterInhosno =  data.obj.consultGroup.consulterInhosno;//住院号类型
                        if(_this.consulterInhosno){
                            _this.consulterInhosnoType=1
                        }else{
                            _this.consulterInhosnoType=0
                        }
                        _this.auxiliaryDiagnose = data.obj.consultGroup.auxiliaryDiagnose?data.obj.consultGroup.auxiliaryDiagnose:"影像",//辅助类型
                        _this.consultGroupType = data.obj.consultGroup.consultGroupType;//会诊类型
                        _this.consultContent = data.obj.consultGroup.consultContent;//主诉
                        _this.consultReason = data.obj.consultGroup.consultReason;//会诊目的
                        _this.beforeDiagnose = data.obj.consultGroup.beforeDiagnose;//会诊前诊断
                        if(data.obj.consultGroup.consultGroupNo.charAt(0)=="A"){//医助医会诊
                            _this.type = "ASS";
                            _this.hopeHosId = data.obj.consultGroup.hopeHosId;//期望医院ID
                            _this.hopeDeptId = data.obj.consultGroup.hopeDeptId;//期望科室
                            _this.hopeDocId = data.obj.consultGroup.hopeDocId;//期望医生ID
                            _this.initHosId = data.obj.consultGroup.initHosId;//申请医院ID
                            _this.initDeptId = data.obj.consultGroup.initDeptId;//申请科室
                            _this.initDocId = data.obj.consultGroup.initDocId;//申请医生ID
                            // _this.getDeptList();

                            _this.getDeptList();
                            _this.getDocList();
                            _this.getInitDeptList();
                            _this.getInitDocList();
                            _this.hosList =  [{"hosName": data.obj.consultGroup.hopeHosName, "id": data.obj.consultGroup.hopeHosId}];
                            _this.deptList = [{"deptName": data.obj.consultGroup.hopeDeptName, "id": data.obj.consultGroup.hopeDeptId}];
                            _this.docList = [{"docName": data.obj.consultGroup.hopeDocName, "id": data.obj.consultGroup.hopeDocId}];
                            _this.initHosList =  [{"hosName": data.obj.consultGroup.initHosName, "id": data.obj.consultGroup.initHosId}];
                            _this.initDeptList = [{"deptName": data.obj.consultGroup.initDeptName, "id": data.obj.consultGroup.initDeptId}];
                            _this.initDocList = [{"docName": data.obj.consultGroup.initDocName, "id": data.obj.consultGroup.initDocId}];

                        }else {//医医会诊
                            _this.type = "DOC";
                            _this.hopeHosId = data.obj.consultGroup.acceptHosId;//期望医院ID
                            _this.hopeDeptId = data.obj.consultGroup.acceptDeptId;//期望科室
                            _this.hopeDocId = data.obj.consultGroup.acceptDocId;//期望医生ID
                            _this.initHosId = data.obj.consultGroup.initHosId;//申请医院ID
                            _this.initDeptId = data.obj.consultGroup.initDeptId;//申请科室
                            _this.initDocId = data.obj.consultGroup.initDocId;//申请医生ID
                            _this.hosList =  [{"hosName": data.obj.consultGroup.acceptHosName, "id": data.obj.consultGroup.acceptHosId}];
                            _this.deptList = [{"deptName": data.obj.consultGroup.acceptDeptName, "id": data.obj.consultGroup.acceptDeptId}];
                            _this.docList = [{"docName": data.obj.consultGroup.acceptDocName, "id": data.obj.consultGroup.acceptDocId}];
                        }
                        _this.hopeTime = data.obj.consultGroup.hopeTime;//期望时间

                        _this.consultDetail = data.obj;
                        _this.getrecord();
                        //初始化选中医院，科室，医生列表，否则后续提若交不修改这些值无法获取数据
                        //获取邀请医生列表
                        if(data.obj.inviteVoList){
                            _this.$store.dispatch("getInviteDocList", data.obj.inviteVoList);
                        }
                        //获取附件并分组图片和文件
                        _this.fileList = [];//清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
                        _this.imgList = [];//清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
                        fileClassification(data.obj.attaList, _this.imgList, _this.fileList);
                        _this.uploadFileCount = _this.imgList.length;
                    }else if(data.obj.consult.consultStatus === "NEEDCOMMENT"||data.obj.consultStatus === "FINSH"){// 已结束会诊
                        _this.$router.push({ name: "remoteEvaluate", params: { consultId: _this.consultId }} );
                    }else if(data.obj.consult.consultStatus === "CANCEL"){// 已取消会诊
                        _this.$router.push({ name: "remoteReject", params: { consultId: _this.consultId }} );
                    }
                }, function(){
                    _this.isSuccess = true;
                    _this.$router.go(-1);
                });
            },
            changeConsulterInhosno: function(type){//修改住院号类型
                if(type==0){
                    this.consulterInhosno = "门诊"
                }else {
                    this.consulterInhosno = "";
                }
            },
            hiddenAddDocBox: function(){//隐藏要求会诊框
                this.isShowAddDocBox = false;
            },
            inviteVideo: function(){//邀请会诊
                if(this.isConsultReady){
                    this.isShowAddDocBox = true;
                }else {
                    Message({
                       showClose: true,
                       message: "未安排视频时间无法邀请",
                       type: "error"
                    });
                }
            },
            linkToEnterHushi:function(){
                let _this = this;
                if(localStorage.getItem("txtConfID"+_this.docIds)){
                    _this.form.txtConfID=localStorage.getItem("txtConfID"+_this.docIds);
                    DirectEnterConf(_this.form).then((res)=>{

                        if(res.result=="1012"){

                            Message({
                                showClose: true,
                                message: "客户端已经启动，请确认!",
                                type: "success"
                            });
                        }else if(res.result=="0"){
                            Message({
                                showClose: true,
                                message: "客户端正在启动，请稍等...",
                                duration:15000,
                                type: "success"
                            });
                            let strs=res.message.split(".")
                            let strd=_this.version.split(".")
                            let strss=[];
                            let strdd=[];
                            for(var i=0;i<strs.length;i++){
                             strss.push(strs[i]);
                            }
                            for(var j=0;j<strs.length;j++){
                            strdd.push(strd[j]);
                            }
                          if(strss[0]<strdd[0]||strss[1]<strdd[1]||strss[2]<strdd[2]||strss[3]<strdd[3]){
                             MessageBox.confirm('抱歉，您的客户端不是最新版本，是否下载最新版本？', '提示',{
                              confirmButtonText: '确定下载',
                              showCancelButton:false,
                              type: 'warning'
                              }).then(()=>{
                              window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                            })
                           }else if(strss[0]==strdd[0]||strss[1]==strdd[1]||strss[2]==strdd[2]||strss[3]==strdd[3]){
                            
                           }else if(strss[0]>strdd[0]||strss[1]>strdd[1]||strss[2]>strdd[2]||strss[3]>strdd[3]){                            
                           }
                        }else if(res.result=="1011"){
                            MessageBox.confirm('请先安装视频客户端', '提示',{
                                confirmButtonText: '确定下载',
                                showCancelButton:false,
                                type: 'warning'
                            }).then(()=>{
                                window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                            })
                        }
                    }).catch(()=>{
                        MessageBox.confirm('请先安装视频客户端', '提示',{
                            confirmButtonText: '确定下载',
                            showCancelButton:false,
                            type: 'warning'
                        }).then(()=>{
                            window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                        })
                    });
                }else{
                    let options = {
                        consultId: _this.consultId,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.intovideo"
                    };
                    axiosUtil(options, function(data){

                        window.localStorage.setItem("txtConfID"+_this.docIds,data.obj.room.roomCallid);
                        _this.form.txtConfID=localStorage.getItem("txtConfID"+_this.docIds);

                        DirectEnterConf(_this.form).then((res)=>{
                            _this.showsVideo=true;

                            if(res.result=="1012"){

                                Message({
                                    showClose: true,
                                    message: "客户端已经启动，请确认!",
                                    type: "success"
                                });
                            }else if(res.result=="0"){
                                Message({
                                    showClose: true,
                                    message: "客户端正在启动，请稍等...",
                                    duration:15000,
                                    type: "success"
                                });
                                let strs=res.message.split(".")
                                let strd=_this.version.split(".")
                                let strss=[];
                                let strdd=[];
                                for(var i=0;i<strs.length;i++){
                                    strss.push(strs[i]);
                                }
                                for(var j=0;j<strs.length;j++){
                                    strdd.push(strd[j]);
                                }
                                if(strss[0]<strdd[0]||strss[1]<strdd[1]||strss[2]<strdd[2]||strss[3]<strdd[3]){
                                    MessageBox.confirm('抱歉，您的客户端不是最新版本，是否下载最新版本？', '提示',{
                                        confirmButtonText: '确定下载',
                                        showCancelButton:false,
                                        type: 'warning'
                                    }).then(()=>{
                                        window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                                    })
                                }else if(strss[0]==strdd[0]||strss[1]==strdd[1]||strss[2]==strdd[2]||strss[3]==strdd[3]){
                                    
                                }else if(strss[0]>strdd[0]||strss[1]>strdd[1]||strss[2]>strdd[2]||strss[3]>strdd[3]){                            
                                }
                            }else if(res.result=="1011"){
                                MessageBox.confirm('请先安装视频客户端', '提示',{
                                    confirmButtonText: '确定下载',
                                    showCancelButton:false,
                                    type: 'warning'
                                }).then(()=>{
                                    window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                                })
                            }
                        }).catch(()=>{
                            MessageBox.confirm('请先安装视频客户端', '提示',{
                                confirmButtonText: '确定下载',
                                showCancelButton:false,
                                type: 'warning'
                            }).then(()=>{
                                window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                            })
                        });
                    });
                }
            },
            linkToEnter: function(type){//进入/测试视频
                let _this = this;
                let options = {
                    consultId: _this.consultId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.intovideo"
                };
                axiosUtil(options, function(data){

                    let roomPassword = null;
                    let roomNo=data.obj.room.roomNo
                    if(data.obj.room.roomPassword){
                        roomPassword = data.obj.room.roomPassword;
                    }else{
                        roomPassword = data.obj.room.roomGhostPassword;
                    }
                    let options={
                        key:"CONSULT_GROUP_VIDEO_SP_NAME",
                        defaultString:"cci",
                        Service:"smarthos.system.param.string"
                    }
                    axiosUtil(options,function(data){

                        _this.isVideoReady = true;
                        _this.isShowVideo = true;
                        if(type!="test"){
                            _this.$emit("showList");//显示视频间人员列表
                            _this.isTest = false;
                        }else {
                            _this.isTest = true;
                        }
                        let docName = JSON.parse(sessionStorage.getItem("loginInfo")).docName;
                        let src = encodeURI("https://webrtc.onecc.me/zl/?conference=" + roomNo + "&name=" + docName + "&pin=" + roomPassword + "&join=1");

                        setTimeout(function(){ _this.videoSrc = src; _this.isVideoReady = false; _this.isEnd=true;}, 0);
                    })
                });
            },
            linkToEnterTest: function(){// 测试环境
                this.isTest = true;
                this.isShowVideo = true;
                this.$nextTick(() => {// 需要先更新dom否则获取不到video
                    showTestVideo(this.$refs.video);
                });
            },
            linkEnterHD: function(HDRoomNum){//高清设备
                let _this = this;
                _this.isTest = false;
                _this.videoSrc = "";// 防止第一次进入电脑接口，然后进入高清设备电脑端会有画面
                let accountNo = HDRoomNum ? HDRoomNum : "";
                let options = {
                    consultId: _this.consultId,
                    accountNo: accountNo,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.intovideo"
                };
                axiosUtil(options, function(data){
                    _this.isVideoReady = true;
                    _this.isShowVideo = true;
                    _this.$emit("showList");//显示视频间人员列表
                });
            },
            linkEnterHDTest: function (HDRoomNum) {//测试环境
                let _this = this;
                _this.isTest = true;
                _this.videoSrc = "";// 防止第一次进入电脑接口，然后进入高清设备电脑端会有画面
                let accountNo = HDRoomNum ? HDRoomNum : "";
                let options = {
                    consultId: _this.consultId,
                    accountNo: accountNo,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.intovideo"
                };
                axiosUtil(options, function(data){
                    _this.isVideoReady = true;
                    _this.isShowVideo = true;
                    _this.isTest = true;
                });
            },
            linkToOut: function(){//退出视频
                let _this = this;
                if(_this.isTest){// 测试环境
                    _this.isTest = false;
                    _this.isShowVideo = false;
                    _this.$refs.video.src = "";
                    return;
                }
                this.$emit("hiddenList");//隐藏视频间人员列表
                let options = {
                    consultId: _this.consultId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.exitvideo"
                };
                axiosUtil(options, function(data){
                    _this.isShowVideo = false;
                    //_this.$router.push("/main/remoteConsultation");
                });
            },
            linkToEnd: function(){//结束视频
                MessageBox.confirm('本次会诊已经顺利完成，是否确定结束？(点击确定后无法再次进入视频)', '提示', {
                    confirmButtonText: '确定结束',
                    cancelButtonText: '再想想',
                    type: 'warning'
                }).then(() => {
                    let _this = this;
                    if(localStorage.getItem("txtConfID"+_this.docIds)){
                        localStorage.removeItem("txtConfID"+_this.docIds);
                    }
                    let options = {
                        consultId: _this.consultId,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.complete"
                    };
                    axiosUtil(options, function(data){
                        _this.$router.push({ name: "remoteEvaluate", params: { consultId: _this.consultId }} );
                    });
                }).catch(() => {return;});
            },
            linkToCancel: function(){// 取消会诊
                MessageBox.prompt('请输入取消理由?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then((inputValue) => {
                    let _this = this;
                    let options = {
                        consultId: _this.consultId,
                        disagreeReason: inputValue.value,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.cancel"
                    };
                    axiosUtil(options, function(data){
                        _this.$router.push({ name: "remoteReject", params: { consultId: _this.consultId }} );
                    });
                }).catch(() => {return;});

            },
            getHospList: function(){//获取医院列表,参数未显示下拉菜单和隐藏下拉菜单的boolean，下来为true
                    this.loading = true;
                    let _this = this;
                    let options = {
                        Service: "smarthos.system.hos.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.hospList = data.list;
                    });
            },
            getHospId: function(id){//获取选择的医院id
                this.hopeHosId = id;
                this.getDeptList();
            },
            getDeptList: function(query){//获取科室列表
                if(this.hopeHosId){//如果医院已经选择完成则可以选择科室
                    this.loading = true;
                    let _this = this;
                    let options = {
                        hosId: _this.hopeHosId,
                        Service: "smarthos.system.dept.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.deptList = data.list;
                    });

                }else{
                   Message({
                       showClose: true,
                       message: "请先选择医院",
                       type: "error"
                   });
                   return;
                }
            },
            getDeptId: function(id){//获取选择的科室ID
                this.hopeDeptId = id;
                this.hopeDocId="";
                this.getDocList();
            },
            getDocList: function(query){//获取医生列表
                let  _this=this;

                if(_this.hopeDeptId){//如果医院和科室已经选择完成则可以选择科室
                    _this.loading = true;
                    let options = {
                        hosId: _this.hopeHosId,
                        deptId: _this.hopeDeptId,
                        Service: "smarthos.user.doc.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.docList = data.list;
                    });
                }else{
                   Message({
                       showClose: true,
                       message: "请先选择医院和科室",
                       type: "error"
                   });
                   return;
                }
            },
            getDocId: function(id){//获取选择的医生id
                this.hopeDocId = id;
            },
            getInitHospId: function(hospId){//获取选择申请的医院id
                let _this=this;
                _this.initHosId = hospId;
                this.initDeptId = "";
                this.initDocId = "";
                _this.getInitDeptList();
            },
            getInitDeptList: function(query){//获取申请科室列表
                this.loading = true;
                let _this = this;
                let options = {
                    hosId: _this.initHosId,
                    Service: "smarthos.system.dept.list"
                };
                axiosUtil(options, function(data){
                    _this.loading = false;
                    _this.initDeptList = data.list;

                });
            },
            getInitDeptId: function(id){// 获取申请科室id
                this.initDeptId = id;
                this.initDocId = "";
                this.getInitDocList();
            },
            getInitDocList: function(query){//获取医生列表
                if(this.initDeptId){//如果医院和科室已经选择完成则可以选择科室
                    this.loading = true;
                    let _this = this;
                    let options = {
                        hosId: _this.initHosId,
                        deptId: _this.initDeptId,
                        Service: "smarthos.user.doc.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.initDocList = data.list;
                    });
                }else{
                    Message({
                        showClose: true,
                        message: "请先选择科室",
                        type: "info"
                    });
                    return;
                }
            },
            getInitDocId: function(id){//获取申请的医生id
                this.initDocId = id;
            },
            consultSubmit: function(){//提交完善资料
                let _this = this;
                let consulterInhosno = _this.consulterInhosno==""?"门诊":_this.consulterInhosno;
                for(let i=0; i<_this.upLoadList.length; i++){
                    _this.attaIdList.push(_this.upLoadList[i].id);
                };


                if(!_this.isShowVideo&&_this.isConsultReady){//安排医生和时间后不能更改
                    let options = {
                        consultId: _this.consultId,
                        consultContent: html2Escape(_this.consultContent),
                        consultReason: html2Escape(_this.consultReason),
                        beforeDiagnose: html2Escape(_this.beforeDiagnose),
                        attaIdList: _this.attaIdList,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.perfect"
                    };
                    axiosUtil(options, function(data){
                        Message({
                            showClose: true,
                            message: "提交成功",
                            type: "success"
                        });
                        _this.$router.push("/main/RemoteConsulations");
                    });
                }
                // else if(!_this.auditStatus){
                //     let options = {
                //         consultId: _this.consultId,
                //         consultContent: html2Escape(_this.consultContent),
                //         consultReason: html2Escape(_this.consultReason),
                //         beforeDiagnose: html2Escape(_this.beforeDiagnose),
                //         attaIdList: _this.attaIdList,
                //         token: localStorage.getItem("token"),
                //         Service: "smarthos.consult.group.perfect"
                //     };
                //     axiosUtil(options, function(data){
                //         Message({
                //             showClose: true,
                //             message: "提交成功",
                //             type: "success"
                //         });
                //         _this.$router.push("/main/RemoteConsulations");
                //     });
                // }
                else {
                    let options = {
                        consultId: _this.consultId,
                        consulterName: html2Escape(_this.consulterName),
                        consulterIdcard: _this.consulterIdcard,//患者身份证
                        consulterMobile: html2Escape(_this.consulterMobile),
                        consulterJob: html2Escape(_this.consulterJob),
                        consulterInhosno: consulterInhosno,//患者住院号，或者填写‘门诊’
                        consultGroupType: _this.consultGroupType,
                        maritalStatus:_this.maritalStatus,
                        consultContent: html2Escape(_this.consultContent),
                        consultReason: html2Escape(_this.consultReason),
                        beforeDiagnose: html2Escape(_this.beforeDiagnose),
                        hopeHosId: _this.hopeHosId,
                        consulterAreaCode:_this.regionId?_this.regionId:_this.cityId,
                        consulterAddress:_this.lxdz,
                        hopeDeptId: _this.hopeDeptId,
                        hopeDocId: _this.hopeDocId,
                        hopeTime: _this.hopeTime?html2Escape(_this.hopeTime):"",
                        attaIdList: _this.attaIdList,
                        initHosId:_this.initHosId,
                        initDeptId:_this.initDeptId,
                        initDocId: _this.initDocId,//发起方医生ID
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.modify"
                    };
                    axiosUtil(options, function(data){
                        Message({
                            showClose: true,
                            message: "提交成功",
                            type: "success"
                        });
                        _this.$router.push("/main/RemoteConsulations");
                    });
                }
            },
            beforeUpload: function (file) {//上传图片/文件前钩子函数
                let _this = this;
                if(_this.uploadFileCount < upLoadFileCountMax) {//如果上传数量小于9
                    _this.uploadFileCount++;
                    return new Promise(function (resove, reject) {
                        _this.uploadData = Object.assign({
                            'file': file,
                            'module':'CONSULT_GROUP',
                            'fileType':"IMAGE",
                            'Service': "smarthos.system.file.upload"
                        }, upLoadBasicParam);
                        resove(true);
                    });
                }else {
                    _this.uploadFileCount++;// 如果返回false，则会调用移除图片函数 ，uploadFileCount会减1
                    Message({
                       showClose: true,
                       message: "上传图片数量不能多于9张",
                       type: "info"
                    });
                    return false;
                }
            },
            beforeUploadFile: function (file) {
                let _this = this;
                let maxsize=1024*500;
                let type= file.name.replace(/.+\./,"")

                if(type=="pdf"||type=="xls"||type=="xlsx"||type=="doc"||type=="docx"||type=="txt"||type=="rar"||type=="zip"||type=="PDF"){
                    
                }else{
                    Message({
                        showClose: true,
                        message:"不支持该类型文件上传",
                        type: "error"
                    })
                    return false;
                }
                if(file.size/1024>maxsize){
                    Message({
                        showClose: true,
                        message:"附件大小不能大于500mb",
                        type: "error"
                    })
                    return false;
                }else{
                    return new Promise(function (resove, reject) {
                        _this.uploadData = Object.assign({
                            'file': file,
                            'module':'CONSULT_GROUP',
                            'fileType':"OTHER",
                            'Service': "smarthos.system.file.upload"
                        }, upLoadBasicParam);
                        resove(true);
                    });
                }
            },
            onSuccessImg: function(response, file, fileList){//上传图片成功后钩子

                if(response.succ){
                    this.imgUploadList = fileList;
                }else {
                   Message({
                       showClose: true,
                       message: response.msg,
                       type: "error"
                   });
                }
            },
            onRemoveImg: function (file, fileList) {//删除上传图片
                if(this.uploadFileCount>0){//数量减1
                    this.uploadFileCount--;
                }
                this.imgUploadList = fileList;
            },
            onSuccessFile: function(response, file, fileList){//上传文件成功后钩子
                if(response.succ){
                    this.fileUploadList = fileList;
                    
                }else {
                   Message({
                       showClose: true,
                       message: response.msg,
                       type: "error"
                   });
                }
            },
            onRemoveFile: function (file, fileList) {//删除上传文件
                this.fileUploadList = fileList;
            },
            handleImageAmplify: function(index=0, imgList, ev){//获取的图片放大
                let e = ev || event;
                let element = e.target || e.srcElement;
                let src = element.src;
                let obj = {
                    imgList: imgList,
                    index: index
                };
                this.$store.dispatch("getAmplifyImageArr", obj);// 储存需要放大的数组，用于左右按钮切换
                imageAmplify(src);
            },
            handlePreview: function (file) {//上传的图片放大
                let obj = {
                    imgList: [],
                    index: 0
                };
                this.$store.dispatch("getAmplifyImageArr", obj);// 储存需要放大的数组，用于左右按钮切换
                imageAmplify(file.url);
            },
            cancelConsult: function () {//申请撤销会诊
                let _this = this;
                MessageBox.confirm('取消会诊申请将清空所有内容，是否继续取消?',{
                    confirmButtonText: '确定取消',
                    cancelButtonText: '再想想',
                }).then(() => {
                    
                    let options = {
                        consultId: _this.consultId,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.cancel"
                    };
                    axiosUtil(options,function(data){
                        _this.$router.push("/main/RemoteConsulations");

                    });
                }).catch(() => {
                    
                });
            },
            ...mapActions(['changeSideItem'])
        },
    }
</script>
